import { Pipe, PipeTransform } from '@angular/core';
import { HaEditIcdModal } from '../models/HaEditIcd.model';

@Pipe({
  name: 'haIcdcodeDatapipe'
})
export class HaIcdcodeDatapipePipe implements PipeTransform {

  transform(icdData: HaEditIcdModal[], searchTermIcd: string): HaEditIcdModal[] {
    //console.log("search term is"+searchTermIcd);
    //console.log("icddata"+icdData);
    if (!icdData || !searchTermIcd) { return icdData; }
    
    icdData.forEach(element => {
  if(element.description==null ){
    element.description="";
  }
  if(element.category==null ){
    element.category="";
  }
  if(element.helpText==null ){
    element.helpText="";
  }
});
    return icdData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermIcd.toLowerCase().trim()) !== -1 

      ||
      ad.description.toLowerCase().indexOf(searchTermIcd.toLowerCase().trim()) !== -1
      ||
      ad.category.toLowerCase().indexOf(searchTermIcd.toLowerCase().trim()) !== -1
      ||
      ad.helpText.toLowerCase().indexOf(searchTermIcd.toLowerCase().trim()) !== -1

    );
  }

}
